// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GgUT","buttons":"styles_buttons__2_zcp"};